import { render, staticRenderFns } from "./payMobile.vue?vue&type=template&id=357a2640&scoped=true&"
import script from "./payMobile.vue?vue&type=script&lang=js&"
export * from "./payMobile.vue?vue&type=script&lang=js&"
import style0 from "./payMobile.vue?vue&type=style&index=0&id=357a2640&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357a2640",
  null
  
)

export default component.exports